import type { Winner } from '@src/@types/ozonPrizeWinners';
import mainWinnerMaleSrc from '@src/assets/octoberPrizeDraw/avatars/mainWinnerMale.png';

export const MAIN_WINNER: Winner = {
  id: 1,
  phoneNumber: '+79157673302',
  amount: '100 000 ₽',
  avatarSrc: mainWinnerMaleSrc,
  // ФИО добавить в формате 'Иван Ч.'
  fio: '',
};
